<div class="modal-header">
  <h5  *ngIf="emailSent" class="modal-title">Thank You for Registering</h5>
  <h5 *ngIf="!emailSent" class="modal-title" >Sign up</h5>
  <button
          type="button"
          class="close"
          (click)="onClose()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  </button>
</div>
<div class="modal-body pb-5" *ngIf="!emailSent">
  <button class="login-button  google-login"
          (click)="loginWithGoogle()">
    <span>Continue with Google</span>
    <img src="../assets/icons/google.png" alt="google-logo" />

  </button>
  <div class="w-100 or">or</div>
    <div class="form-control">
      <input [(ngModel)]="email" type="email" placeholder="Email" />
    </div>
    <button class="login-button" (click)="SignInWithEmailLink(email)"
            >Sign up with email</button>
    <p><small>Link to login will be sent to your email</small></p>

</div>

<div class="modal-body" *ngIf="emailSent">
    <p class="text-center">We have sent a confirmation email to <strong>{{email}}</strong>.</p>
    <p class="text-center">Please check your email (including spam folder) and click on the link to verify your email address.</p>
</div>
